var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2373 1.68983L16.1229 5.90027C16.448 6.37459 16.9266 6.72236 17.4782 6.88495L22.3743 8.32822C23.3852 8.62622 23.7817 9.84642 23.139 10.6817L20.0263 14.7272C19.6756 15.1829 19.4928 15.7456 19.5086 16.3204L19.649 21.4228C19.6779 22.4764 18.64 23.2305 17.6469 22.8774L12.8376 21.1672C12.2958 20.9745 11.7042 20.9745 11.1624 21.1672L6.35305 22.8774C5.36004 23.2305 4.32207 22.4764 4.35105 21.4228L4.49138 16.3204C4.50719 15.7456 4.32436 15.1829 3.97371 14.7272L0.861044 10.6817C0.21835 9.84642 0.614817 8.62622 1.62574 8.32822L6.5218 6.88495C7.07337 6.72236 7.55202 6.37459 7.8771 5.90027L10.7627 1.68983C11.3585 0.820475 12.6415 0.820475 13.2373 1.68983Z",
    fill: "white",
    stroke: "#B3B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.7f163122882983bb49ca8d299a1a346b.svg";
export { ForwardRef as ReactComponent };